import { Injectable } from '@angular/core';

@Injectable()
export class UserblockService {
    public userBlockVisible: boolean;
    public sideBarCollapsed: boolean;
    constructor() {
        // initially visible
        this.userBlockVisible  = true;
    }

    public getVisibility() {
        return this.userBlockVisible;
    }

    public setVisibility(stat = true) {
        this.userBlockVisible = stat;
    }

    public toggleVisibility() {
        this.userBlockVisible = !this.userBlockVisible;
    }

}
